import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosApiInstance } from "../../../app/axios";
import { API_URL } from "../../../app/config";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IAboutDetails } from "../aboutModel";

export const updateAbout = createAsyncThunk(
  "About/InsertAbout",
  async (UserData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/About/InsertAbout`,
        UserData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating about details:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAboutDetails = createAsyncThunk(
  "About/FindByIDAbout",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/About/FindByIDAbout`
      );
      const result = response.data?.Data as any;
      return {
        ID: result?.ID,
        AboutDescription: result?.AboutDescription || "",
        VisionDescription: result?.VisionDescription || "",
        GoalDescription: result?.GoalDescription || "",
        MissionDescription: result?.MissionDescription || "",
        AboutAltText: result?.AboutAltText || "",
        VisionAltText: result?.VisionAltText || "",
        GoalAltText: result?.GoalAltText || "",
        MissionAltText: result?.MissionAltText || "",
        AboutImage: result?.AboutImage,
        VisionIcon: result?.VisionIcon,
        VisionImage: result?.VisionImage,
        GoalIcon: result?.GoalIcon,
        GoalImage: result?.GoalImage,
        MissionIcon: result?.MissionIcon,
        MissionImage: result?.MissionImage,
      } as IAboutDetails;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching about details:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const AboutDetailsImageUpload = createAsyncThunk(
  "About/AboutImageUpdate",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/About/AboutImageUpdate`,
        formData
        // {
        //   headers: { "content-type": "multipart/form-data" },
        // }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error upload about details images :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
